export default function toNumber(input) {
  const num = Number(input);

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(num)) return undefined;
  return num;
}
